import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "o-pager" }
const _hoisted_2 = { class: "o-pager__wrap" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svgIco = _resolveComponent("svgIco")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$root.totalPages>1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["o-pager__btn o-pager__prev", {'is-disable':_ctx.$root.page===1}]),
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.$root.page = _ctx.$root.page > 1 ? _ctx.$root.page-1:1))
          }, [
            _createVNode(_component_svgIco, { icon: "arrow-left" })
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$root.pages, (i) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
          ($options.pageToShow(i))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["o-pager__page", {'is-active':_ctx.$root.page==i }]),
                onClick: $event => (_ctx.$root.page=i)
              }, _toDisplayString(i), 11 /* TEXT, CLASS, PROPS */, _hoisted_3))
            : (!$options.pageToShow(i) && i==2 || !$options.pageToShow(i) && i == _ctx.$root.totalPages-1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "..."))
              : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      }), 128 /* KEYED_FRAGMENT */)),
      (_ctx.$root.totalPages>1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: _normalizeClass(["o-pager__btn o-pager__next", {'is-disable':_ctx.$root.page==_ctx.$root.totalPages}]),
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.$root.page = _ctx.$root.page < _ctx.$root.totalPages ? _ctx.$root.page+1:_ctx.$root.totalPages))
          }, [
            _createVNode(_component_svgIco, { icon: "arrow-right" })
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}